module.exports = __webpack_public_path__ + "media/spring_haze.d3b40744.webm";